var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3848_1224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 61
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#D54646"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3848_1224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.748 18.0821C17.3974 17.0235 16.8699 16.7622 16.676 16.3456C16.4931 15.9525 16.6071 15.4212 16.6071 13.9516C16.6071 10.7868 18.6384 9.95604 20.6703 9.95604H24.7342C21.158 9.95604 20.6703 8.01758 20.6703 8.01758L32.8619 6C37.3322 6 40.9896 9.56044 40.9896 13.9121H43.0216C43.0216 13.9121 43.8853 16.4345 42.8414 18.3783C44.024 19.0974 44.8182 20.3988 44.8182 21.8766C44.8182 24.1266 42.9773 25.9675 40.7273 25.9675V28.013C40.7273 30.7254 39.6498 33.3268 37.7318 35.2448C36.3074 36.6691 34.5063 36.5019 32.5626 36.3215C31.8889 36.2589 31.1981 36.1948 30.5 36.1948C29.8019 36.1948 29.1111 36.2589 28.4374 36.3215C26.4937 36.5019 24.6926 36.6691 23.2682 35.2448C21.3502 33.3268 20.2727 30.7254 20.2727 28.013V25.9675C18.0227 25.9675 16.1818 24.1266 16.1818 21.8766C16.1818 20.1648 17.2474 18.6898 18.748 18.0821ZM53 54.6039C53 47.813 47.5182 42.3312 40.7273 42.3312H20.2727C13.4818 42.3312 8 47.813 8 54.6039V62.7857H53V54.6039Z",
    fill: "#171C8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.19d67b651b26b3777f680c9f4c7e2a48.svg";
export { ForwardRef as ReactComponent };